const C3_GRAPHIC_CODE_PATTERN = /^GFX-(\d+)$/i;

export function nextC3GraphicCode(existingCodes: readonly string[]): string {
    const highest = existingCodes.reduce((currentHighest, code) => {
        const match = C3_GRAPHIC_CODE_PATTERN.exec(code.trim());
        if (!match) return currentHighest;
        return Math.max(currentHighest, Number(match[1]));
    }, 0);

    return `GFX-${(highest + 1).toString().padStart(4, '0')}`;
}
